import applicationSettings from 'translations/en/administration/applicationSettings'
import attributes from 'translations/en/administration/attributes'
import breaks from 'translations/en/administration/breaks'
import config from 'translations/en/administration/config'
import departments from 'translations/en/administration/departments'
import hiringData from 'translations/en/administration/hiringData'
import holidays from 'translations/en/administration/holidays'
import wagePremiums from 'translations/en/administration/wagePremiums'
import permissions from 'translations/en/administration/permissions'
import positions from 'translations/en/administration/positions'
import punchRules from 'translations/en/administration/punchRules'
import recurringJobsTests from 'translations/en/administration/recurringJobsTests'
import requestOptions from 'translations/en/administration/requestOptions'
import scheduleTypes from 'translations/en/administration/scheduleTypes'
import structure from 'translations/en/administration/structure'
import tags from 'translations/en/administration/tags'
import teams from 'translations/en/administration/teams'

export default {
  APPLICATION_SETTINGS: `Application settings`,
  ATTRIBUTES: `Attributes`,
  BILLING: `Billing`,
  BREAKS: `Breaks`,
  BREAKS_RULES: `Breaks rules`,
  CODE: {
    LABEL: `Import Code`,
    PLACEHOLDER: `Enter a code`,
    DESCRIPTION: 'This code will be used in the import tools to assign {{resources}} to other resources.'
  },
  IMPORTCODE: {
    LABEL: `Import Code`,
    PLACEHOLDER: `Enter a code`
  },
  POSITIONCODE: {
    LABEL: `Import Code`,
    PLACEHOLDER: `Enter a code`
  },
  DEPARTMENTS: `Departments`,
  FILTER_SORTS: `Filter and Sorts`,
  HIRING_DATA: `Hiring data`,
  IMPORT: `Import`,
  WAGEPREMIUM: `Wage premiums`,
  PERMISSIONS: `Permissions`,
  POSITIONS: `Positions`,
  PUNCH_RULES: `Punch rules`,
  REQUEST_OPTIONS: `Request options`,
  SCHEDULE_TYPES: `Schedule types`,
  STRUCTURE: `Structure`,
  TAGS: `Tags`,
  TEAMS: `Teams`,
  HOLIDAYS: `Holidays`,
  ENTER_USERNAME_CONFIRM_DELETE: `Please enter your username to confirm the deletion:`,
  ENTER_USERNAME_PLACEHOLDER: `Enter your username`,
  SEE_COLUMNS: `See columns`,
  SORT_BY: `Sort by`,
  CONFIG_DEFAULT: `Default filters`,
  CONFIG_FILTER: `Filters`,
  CONFIG_LISTS: `Types of lists`,
  CONFIG_PROCEDURE: `List procedures`,
  CONFIG_SORT: `Sorting orders`,
  PERMISSIONS_ACCESS: `Allowed company permissions`,
  VALID_IMPORT_CODE: `Import code can only contain letters, numbers, hyphens ( - ) or underscores ( _ ), and no spaces`,
  TESTS: `Tests`,
  groupNames: {
    CONFIGURATION: `Configuration`,
    TIME_PAY: `Time and attendance`,
    PEOPLE: `People`,
    SCHEDULE: `Schedule`
  },
  confirmDeletion: {
    ERROR_DELETING: `Error deleting resource.`,
    ERROR_LOADING: `Error loading resources that will be impacted.`,
    BAD_USERNAME_CONFIRMATION: `Must match your username`,
    USERNAME_IS_REQUIRED: `Username is required`,
    WILL_BE_IMPACTED: `<h6>This action will have the following consequences (deletion or re-assignment of resources).</h6><h6>To confirm you understand, please check all below:</h6>`,
    AFFECTED_TEAMS: `<0>Affected teams:</0> {{ count }}`,
    AFFECTED_LOCATIONS: `<0>Affected locations:</0> {{ count }}`,
    AFFECTED_PROJECTS: `<0>Affected projects:</0> {{ count }}`,
    AFFECTED_STRUCTURES: `<0>Affected positions:</0> {{ count }}`,
    AFFECTED_PUNCHCARDS: `<0>Affected punch cards:</0> {{ count }}`,
    AFFECTED_SHIFTS: `<0>Affected shifts:</0> {{ count }}`,
    AFFECTED_EVENTS: `<0>Affected shifts:</0> {{ count }}`,
    AFFECTED_TEMPLATEEVENTS: `<0>Affected shifts in templates:</0> {{ count }}`,
    AFFECTED_TEMPLATES: `<0>Affected templates:</0> {{ count }}`,
    AFFECTED_USERS: `<0>Affected users:</0> {{ count }}`,
    WARNING: `<0>Warning:</0> This action cannot be <0>undone</0> .`
  },
  ARCHIVE_BUTTON: {
    BAD_MATCH: `The input doesn't match "ARCHIVE"`,
    FIELD_IS_REQUIRED: `This field is required`,
    CONFIRM: {
      LABEL: `Type "ARCHIVE" to confirm`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  DELETE_BUTTON: {
    BAD_MATCH: `The input doesn't match "DELETE"`,
    FIELD_IS_REQUIRED: `This field is required`,
    CONFIRM: {
      LABEL: `Type "DELETE" to confirm`,
      PLACEHOLDER: ``,
      DESCRIPTION: ``
    }
  },
  applicationSettings,
  attributes,
  breaks,
  config,
  departments,
  hiringData,
  holidays,
  wagePremiums,
  permissions,
  positions,
  punchRules,
  recurringJobsTests,
  requestOptions,
  scheduleTypes,
  structure,
  tags,
  teams
}
